import { render } from "./videoBox.vue?vue&type=template&id=24f2b24f&scoped=true"
import script from "./videoBox.vue?vue&type=script&lang=js"
export * from "./videoBox.vue?vue&type=script&lang=js"

import "./videoBox.vue?vue&type=style&index=0&id=24f2b24f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f2b24f"]])

export default __exports__